var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal is-active deprecation-modal" }, [
    _c("div", { staticClass: "modal-background" }),
    _c("div", { staticClass: "modal-content" }, [
      _c("div", { staticClass: "box" }, [
        _c("img", {
          staticClass: "deprecation-logo",
          attrs: { src: "/img/gobo-logo-black.svg", alt: "Gobo" }
        }),
        _c("h1", [_vm._v("App Deprecated")]),
        _c("p", { staticClass: "deprecation-copy" }, [
          _vm._v(
            " This is the old Gobo organizer web app, which has been deprecated in favor of the new, improved experience. Click continue to be taken to the new app. "
          )
        ]),
        _c(
          "a",
          {
            staticClass: "button is-dark is-fullwidth",
            attrs: { href: _vm.destination }
          },
          [_vm._v(" Continue ")]
        ),
        _c(
          "a",
          {
            staticClass: "stay-here",
            on: {
              click: function($event) {
                return _vm.$emit("continue-here")
              }
            }
          },
          [_vm._v(" Continue using this app ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }